import { render, staticRenderFns } from "./ChatBotIcon.vue?vue&type=template&id=12121427"
import script from "./ChatBotIcon.vue?vue&type=script&lang=js"
export * from "./ChatBotIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports